import React, { Fragment, useState } from "react";
import { Alert, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import { EmailAddress, Password, RememberPassword, SignIn } from "../Constant";

import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { getApiError } from "../api/client";
import { useAuth } from "./AuthContext";

const Signin = ({ selected }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [remember, setRemember] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const loginAuth = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login({ email, password }, remember);
      const destination = location.state?.from?.pathname;
      navigate(destination && destination !== "/login" ? destination : "/dashboard", { replace: true });
    } catch (error) {
      toast.error(getApiError(error, "Unable to sign in."));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Fragment>
      <Container fluid={true} className="p-0 login-page">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div className="login-main login-tab">
                <Form className="theme-form" onSubmit={loginAuth}>
                  <H4>{selected === "simpleLogin" ? "" : "Social Presence"}</H4>
                  <P>{"Sign in to your company workspace"}</P>
                  {location.state?.sessionExpired && <Alert color="warning" role="alert">Your session expired. Please sign in again.</Alert>}
                  <FormGroup>
                    <Label className="col-form-label" for="login-email">{EmailAddress}</Label>
                    <Input id="login-email" className="form-control" type="email" autoComplete="email" required onChange={(e) => setEmail(e.target.value)} value={email} />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label" for="login-password">{Password}</Label>
                    <div className="position-relative">
                      <Input id="login-password" className="form-control" type={togglePassword ? "text" : "password"} autoComplete="current-password" required onChange={(e) => setPassword(e.target.value)} value={password} />
                      <button type="button" className="show-hide border-0 bg-transparent" aria-label={togglePassword ? "Hide password" : "Show password"} onClick={() => setTogglePassword(!togglePassword)}>
                        <span className={togglePassword ? "" : "show"}></span>
                      </button>
                    </div>
                  </FormGroup>
                  <div className="position-relative form-group mb-0">
                    <div className="checkbox">
                      <Input id="checkbox1" type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
                      <Label className="text-muted" for="checkbox1">
                        {RememberPassword}
                      </Label>
                    </div>
                    <span className="link text-muted">Contact your administrator for access</span>
                    <Btn attrBtn={{ color: "primary", className: "d-block w-100 mt-2", type: "submit", disabled: submitting }}>{submitting ? "Signing in…" : SignIn}</Btn>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </Fragment>
  );
};

export default Signin;
